import { Conversation, Message } from '../../../services/chatService';

/**
 * Atualiza o estado de uma conversa
 */
export const updateConversationStateInList = (
  conversations: Conversation[],
  conversationId: string,
  newState: string
): Conversation[] => {
  return conversations.map((conv) =>
    conv.id === conversationId ? { ...conv, state: newState as Conversation['state'] } : conv
  );
};

/**
 * Atualiza a última mensagem de uma conversa
 */
export const updateConversationLastMessage = (
  conversations: Conversation[],
  conversationId: string,
  message: Message,
  currentSelectedId: string | null
): Conversation[] => {
  return conversations.map((conv) => {
    if (conversationId && conv.id === conversationId) {
      return {
        ...conv,
        lastMessage: message.content,
        lastMessageAt: message.timestamp || message.createdAt,
        unreadCount:
          conv.id === currentSelectedId
            ? 0
            : (conv.unreadCount || 0) + (message.sender === 'CLIENT' ? 1 : 0),
      };
    }
    return conv;
  });
};

/**
 * Marca uma conversa como lida (zera contador de não lidas)
 */
export const markConversationAsRead = (
  conversations: Conversation[],
  conversationId: string
): Conversation[] => {
  return conversations.map((conv) =>
    conv.id === conversationId ? { ...conv, unreadCount: 0 } : conv
  );
};

/**
 * Filtra conversas por estado
 */
export const filterConversationsByState = (
  conversations: Conversation[],
  state: Conversation['state']
): Conversation[] => {
  return conversations.filter((conv) => conv.state === state);
};

/**
 * Conta conversas aguardando humano
 */
export const countWaitingConversations = (conversations: Conversation[]): number => {
  return conversations.filter((conv) => conv.state === 'AGUARDANDO_HUMANO').length;
};
